import {
  ApiClientError,
  Content,
  Playlist,
  Presentation,
} from '@raydiant/api-client-js';
import { useQueryClient } from 'react-query';
import raydiant from '../clients/raydiant';
import { keys } from '../queryClient';
import useProtectedMutation from './useProtectedMutation';

export default function useCopyContent() {
  const queryClient = useQueryClient();

  const mutation = useProtectedMutation<
    Presentation | Playlist,
    ApiClientError,
    { content: Content; params: { name: string } }
  >(
    async ({ content, params }) => {
      switch (content.resourceType) {
        case 'presentation':
          return await raydiant.copyPresentation(content.id, params);
        case 'playlist':
          return await raydiant.copyPlaylist(content.id, params);
        default:
          throw new Error(`Unknown resource type: ${content.resourceType}`);
      }
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(keys.library());
      },
    },
  );

  return mutation;
}
